var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"residential-list-status-filter"},[_c('CheckboxComponent',{staticClass:"residential-list-status-filter__hide-sold",attrs:{"label":_vm.label},model:{value:(_vm.hideSold),callback:function ($$v) {_vm.hideSold=$$v},expression:"hideSold"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }